<template>
  <v-container class="px-12">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step">
          <v-stepper-header>
            <v-stepper-step
              :complete="step > 1"
              step="1"
              color="var(--vs-marrom-secundario)"
              >Empresa</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step
              :complete="step > 2"
              step="2"
              color="var(--vs-marrom-secundario)"
              >Endereço</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step
              :complete="step > 3"
              step="3"
              color="var(--vs-marrom-secundario)"
              >Usuário</v-stepper-step
            >

            <v-divider></v-divider>

            <v-stepper-step
              :complete="step > 4"
              step="4"
              color="var(--vs-marrom-secundario)"
              >Resultado</v-stepper-step
            >
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="form1" lazy-validation>
                <v-row no-gutters>
                  <v-col lg="3" md="12" class="pr-3">
                    <v-text-field
                      label="CPF ou CNPJ"
                      v-model="cliente.cliStrDocumento"
                      type="text"
                      :rules="[
                        (v) => !!v || 'CPF ou CNPJ é obrigatório',
                        (v) => (v && validoc(v)) || 'CPF/CNPJ inválido',
                      ]"
                      required
                      @input="procurarDocumento()"
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>

                  <v-col lg="9" md="12">
                    <v-text-field
                      label="Nome ou Razão Social"
                      :rules="[
                        (v) => !!v || 'Nome ou Razão Social é obrigatório',
                      ]"
                      v-model="cliente.cliStrNme"
                      type="text"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-text-field
                  label="Telefone"
                  :rules="[(v) => !!v || 'Telefone é obrigatório']"
                  v-model="cliente.cliChaFone1"
                  type="text"
                  v-mask="mask.telefone"
                  required
                  color="var(--vs-azul-secundaria)"
                ></v-text-field>
              </v-form>

              <v-row no-gutters class="pt-7 pb-4">
                <vs-button
                  color="warning"
                  style="min-width: 120px"
                  animation-type="scale"
                  @click="step1()"
                >
                  <template>Continuar</template>
                </vs-button>
                <vs-button
                  color="primary"
                  style="min-width: 120px"
                  border
                  @click="$router.push({ name: 'login' })"
                >
                  <template>Voltar</template>
                </vs-button>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-form ref="form2" lazy-validation>
                <v-row no-gutters>
                  <v-col lg="2" md="12" class="pr-3">
                    <v-text-field
                      label="CEP"
                      :rules="[(v) => !!v || 'CEP é obrigatório']"
                      v-model="cliente.cliChaCep"
                      type="text"
                      v-mask="mask.cep"
                      @input="procurarCEP()"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                  <v-col lg="10" md="12" class="pr-3">
                    <v-text-field
                      label="Endereço"
                      :rules="[(v) => !!v || 'Endereço é obrigatório']"
                      v-model="cliente.cliStrEndereco"
                      type="text"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                  <v-col lg="4" md="12" class="pr-3">
                    <v-text-field
                      label="Bairro"
                      :rules="[(v) => !!v || 'Bairro é obrigatório']"
                      v-model="cliente.cliStrBairro"
                      type="text"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                  <v-col lg="4" md="12" class="pr-3">
                    <v-text-field
                      label="Cidade"
                      :rules="[(v) => !!v || 'Cidade é obrigatório']"
                      v-model="cliente.cliStrCidade"
                      type="text"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                  <v-col lg="4" md="12" class="pr-3">
                    <v-text-field
                      label="UF"
                      :rules="[(v) => !!v || 'UF é obrigatório']"
                      v-model="cliente.cliChaUf"
                      type="text"
                      required
                      color="var(--vs-azul-secundaria)"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>

              <v-row no-gutters class="pt-7 pb-4">
                <vs-button
                  color="warning"
                  style="min-width: 120px"
                  animation-type="scale"
                  @click="step2()"
                >
                  <template>Continuar</template>
                </vs-button>
                <vs-button
                  color="primary"
                  style="min-width: 120px"
                  border
                  @click="step = 1"
                >
                  <template>Voltar</template>
                </vs-button>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-form ref="form3" lazy-validation>
                <v-text-field
                  label="Email"
                  v-model="cliente.cliStrLogin"
                  type="text"
                  required
                  color="var(--vs-azul-secundaria)"
                ></v-text-field>
              </v-form>
              <v-row no-gutters class="pt-7 pb-4">
                <vs-button
                  color="warning"
                  style="min-width: 120px"
                  animation-type="scale"
                  @click="step3()"
                >
                  <template>Criar Conta</template>
                </vs-button>
                <vs-button
                  color="primary"
                  style="min-width: 120px"
                  border
                  @click="step = 2"
                >
                  <template>Voltar</template>
                </vs-button>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="4">
              <div class="text-center subtitle-2 pt-7">{{ resultado.msg }}</div>

              <v-row no-gutters class="pt-7 pb-4 align-center justify-center">
                <vs-button
                  color="warning"
                  style="min-width: 120px"
                  animation-type="scale"
                  @click="$router.push({ name: 'login' })"
                  v-if="resultado.tipo === 'sucesso'"
                >
                  <template>Ir para o Login</template>
                </vs-button>
                <vs-button
                  color="primary"
                  style="min-width: 120px"
                  border
                  @click="step = 3"
                  v-if="resultado.tipo === 'erro'"
                >
                  <template>Voltar</template>
                </vs-button>
              </v-row>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { mask } from "vue-the-mask";
import Util from "../utils/util";

export default {
  directives: {
    mask,
  },
  data() {
    return {
      valid: true,
      resultado: "",
      mask: {
        cnpj: "##.###.###/####-##",
        telefone: "(##)#####-####",
        cep: "#####-###",
      },
      step: 1,
    };
  },
  computed: mapState({
    showError: (state) => state.core.error !== null && state.core.error !== "",
    user: (state) => state.cliente.user,
    cliente: (state) => state.cliente.clienteNovo,
    loading: (state) => state.core.loading,
  }),
  methods: {
    validoc(doc) {
      if (doc.length === 11) {
        //console.log("validCpf", doc, Util.validCpf(doc));
        return Util.validCpf(doc);
      } else if (doc.length >= 14) {
        //console.log("validCnpj", doc, Util.validCnpj(doc));
        return Util.validCnpj(doc);
      }
      return false;
    },
    procurarDocumento() {
      if (this.cliente.cliStrDocumento.length >= 11) {
        this.$store.dispatch("cliente/procurarCliente", {
          cliStrDocumento: this.cliente.cliStrDocumento,
          empIntCod: this.$route.params.id,
        });
      }
    },
    procurarCEP() {
      if (this.cliente.cliChaCep.length === 9) {
        this.$store.dispatch(
          "cliente/procurarCEP",
          this.cliente.cliChaCep.replace(".", "").replace("-", "")
        );
      }
    },
    step1() {
      // console.log("this.$refs.form1", this.$refs.form1);

      const v = this.$refs.form1.validate();
      if (v) {
        this.step = 2;
      }
      // console.log(v);
    },
    step2() {
      // console.log("this.$refs.form2", this.$refs.form2);
      const v = this.$refs.form2.validate();
      if (v) {
        this.step = 3;
      }
      // console.log(v);
    },
    step3() {
      // console.log("this.$refs.form3", this.$refs.form3);
      const v = this.$refs.form3.validate();
      if (v) {
        this.cliente.empresa.empIntCod = this.$route.params.id;
        // this.cliente.cliStrDocumento = this.documento;
        // if (this.cliente.cliIntDocumento != this.cliente.cliStrDocumento) {
        //   this.cliente.cliIntDocumento = null;
        // }
        // console.log(this.cliente);
        this.$store
          .dispatch("cliente/criarcliente", {
            busStrLogin: this.cliente.cliStrLogin,
            cliente: this.cliente,
          })
          .then((r) => {
            // console.log("r", r);
            this.resultado = r;
            this.step = 4;
          });
      }
      // console.log(v);
    },
  },
};
</script>
